/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_CancelInputs */

const zh_subscription_cancel = /** @type {(inputs: Subscription_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅`)
};

const en_subscription_cancel = /** @type {(inputs: Subscription_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription`)
};

const es_subscription_cancel = /** @type {(inputs: Subscription_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Subscription_CancelInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_cancel = /** @type {((inputs?: Subscription_CancelInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_CancelInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_cancel(inputs)
	if (locale === "en") return en_subscription_cancel(inputs)
	return es_subscription_cancel(inputs)
});